import React from "react"
import SibaBreadcrumb from "../components/common/SibaBreadcrumb";
import * as Constants from '../utils/constants'
import { getPath } from "../services/api"
import SibaTitoloPagina from "../components/common/SibaTitoloPagina";
import {
  Container
} from 'design-react-kit';

export const SibaPrivacyPolicy = (props) => {

  // START RENDERING
  return (
    <main>
      <SibaBreadcrumb pageName={Constants.STR_PRIVACY_POLICY_TITOLO} />
      <SibaTitoloPagina titolo={Constants.STR_PRIVACY_POLICY_TITOLO} />
      <Container className="px-2 my-2 text-left" id="privacyTitolo" tag="section">
        <div id="content">
          <a name="contenuto" id="contenuto"></a>
          <div id="titoloInformativa">
            <h2>Informativa estesa</h2>
          </div>
          <hr />
          <hr />
          <div class="widcontstatic">
            <h3>Informazioni sul trattamento dei dati personali</h3>
            <h4>In questa pagina si descrivono le modalità di gestione del sito in riferimento al trattamento dei dati personali degli utenti che lo consultano.</h4>
            <p >
              Si tratta di un'informativa che è resa ai sensi dell'art. 13 del Regolamento UE 679/2016 - Regolamento Generale sulla Protezione dei Dati, che si applica dal 25/05/2018, a coloro che interagiscono con i servizi web di Regione Liguria, accessibili per via telematica a partire dall'indirizzo: 
              <a target="_blank" href="http://www.regione.liguria.it">http://www.regione.liguria.it</a>
            </p>

            <h3>TITOLARE DEL TRATTAMENTO</h3>
            <p >
              A seguito della consultazione del sito sopra citato possono essere trattati dati relativi a persone fisiche identificate o identificabili.Titolare del trattamento è <strong>Regione Liguria</strong>, con sede in Piazza De Ferrari 1 - 16121 Genova, tel. centralino +39 010 54851, <a href="mailto:protocollo@pec.regione.liguria.it">protocollo@pec.regione.liguria.it</a></p>

            <h3>RESPONSABILE DELLA PROTEZIONE DEI DATI</h3>
            <p >
              Il Responsabile della Protezione dei Dati (RPD) è raggiungibile al seguente indirizzo:<br /><strong>Regione Liguria - Responsabile della Protezione dei dati personali, Piazza De Ferrari 1 - 16121 Genova</strong></p>
            <ul >
              email:
              <li>e-mail <a href="mailto:rdp@regione.liguria.it">rdp@regione.liguria.it</a></li>
              <li>posta certificata (pec) <a href="mailto:protocollo@pec.regione.liguria.it">protocollo@pec.regione.liguria.it</a></li>
            </ul>

            <h3>BASE GIURIDICA DEL TRATTAMENTO</h3>
            <p >I dati personali indicati in questa pagina sono trattati da Regione Liguria nell'esecuzione dei propri compiti di interesse pubblico o comunque connessi all'esercizio dei propri pubblici poteri, ivi inclusi:</p>
            <ul >
              <li>esecuzione dei propri compiti di interesse pubblico o comunque connessi all'esercizio dei propri pubblici poteri, ivi incluse le finalità di archiviazione, di ricerca storica e di analisi per scopi statistici;</li>
              <li>adempimenti di obblighi previsti da norme di legge, regolamenti, normativa comunitaria;</li>
              <li>erogazione ed esecuzione dei servizi:"email" e "rimborsi".</li>
            </ul>

            <h3>TIPI DI DATI TRATTATI E FINALIT&Agrave; DEL TRATTAMENTO</h3>

            <h4>Dati di navigazione </h4>
            <p >I sistemi informatici e le procedure software preposte al funzionamento di questo sito acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet. In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer e dei terminali utilizzati dagli utenti, gli indirizzi in notazione URI/URL (Uniform Resource Identifier/Locator) delle risorse richieste, l'orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal server (buon fine, errore, ecc.) ed altri parametri relativi al sistema operativo e all'ambiente informatico dell'utente. Tali dati, necessari per la fruizione dei servizi web, vengono anche trattati allo scopo di:</p>
            <ul >
              <li>erogazione di informazioni e di assistenza tecnica attraverso gli appositi canali di contatto;</li>
              <li>controllare il corretto funzionamento dei servizi offerti.</li>
            </ul>
            <p >I dati di navigazione non persistono per più di sette giorni e vengono cancellati immediatamente dopo la loro aggregazione (salve eventuali necessità di accertamento di reati da parte dell'Autorità giudiziaria).</p>

            <h4>Dati comunicati dall'utente</h4>
            <p >L'invio facoltativo, esplicito e volontario di messaggi agli indirizzi di contatto di Regione Liguria, nonché la compilazione e l'inoltro dei moduli presenti sui siti dell'Ente, comportano l'acquisizione dei dati di contatto del mittente, necessari a rispondere, nonché di tutti i dati personali inclusi nelle comunicazioni. Specifiche informative verranno pubblicate nelle pagine dei siti di Regione Liguria predisposte per l'erogazione di determinati servizi.</p>

            <h4>Cookie e altri sistemi di tracciamento</h4>
            <p >Il sito bolloauto.regione.liguria.it utilizza cookie tecnici per migliorare il servizio. In particolare utilizza: cookie di navigazione e di sessione, che garantiscono la normale navigazione e fruizione del sito web; cookie di funzionalità, che permettono all'utente la navigazione in funzione di una serie di criteri selezionati.</p>

            <h4>Come disabilitare i cookie</h4>
            <p >In caso di accettazione dei cookies, successivamente, avrete la possibilità di rifiutarli, modificando le impostazioni del browser utilizzato per navigare.</p>
            <h4>Su Google Chrome:</h4>
            <ul >
              <li>selezionare la voce "Impostazioni" e andare su "Mostra impostazioni avanzate"</li>
              <li>cliccare sulla scheda "Impostazione contenuti"</li>
              <li>scegliere le impostazioni desiderate</li>
            </ul>

            <h4>Su Firefox:</h4>
            <ul >
              <li>selezionare la voce "Opzioni"</li>
              <li>cliccare sulla scheda "Privacy"</li>
              <li>scegliere le impostazioni desiderate</li>
            </ul>

            <h4>Su Internet Explorer:</h4>
            <ul >
              <li>selezionare la voce "Strumenti" e andare in "Opzioni Internet"</li>
              <li>cliccare sulla scheda "Privacy"</li>
              <li>scegliere le impostazioni desiderate</li>
            </ul>

            <h3>DESTINATARI DEI DATI</h3>
            <p >Sono destinatari dei dati raccolti a seguito della consultazione dei siti sopra elencati i seguenti soggetti designati dal Garante, ai sensi dell'articolo 28 del Regolamento, quali responsabili del trattamento:</p>
            <ul >
              <li><strong>Liguria Digitale Spa</strong>, Parco Scientifico e Tecnologico di Genova - Via Melen 77, 16152 Genova, Telefono: 010 - 65451 Fax: 010 - 6545422 Mail: <a href="mailto:info@liguriadigitale.it">info@liguriadigitale.it</a>; posta certificata <a href="mailto:protocollo@pec.liguriadigitale.it">protocollo@pec.liguriadigitale.it</a> , quale Responsabile del Trattamento incaricato della manutenzione tecnologica del sito;</li>
              <li>Altri Responsabili quali soggetti eventualmente incaricati da Regione Liguria o dal sopra indicato Responsabile per adempiere alla normativa vigente.</li>
            </ul>
            <p >I dati personali raccolti sono altresì trattati dal personale della Regione Liguria, che agisce sulla base di specifiche istruzioni fornite in ordine a finalità e modalità del trattamento medesimo.</p>

            <h3>DIRITTI DEGLI INTERESSATI</h3>
            <p >Gli interessati hanno il diritto di ottenere da Regione Liguria, nei casi previsti, l'accesso ai dati personali e la rettifica o la cancellazione degli stessi o la limitazione del trattamento che li riguarda o di opporsi al trattamento (artt. 15 e ss. del Regolamento). L'apposita istanza a Regione Liguria è presentata contattando il Responsabile della protezione dei dati presso <strong>Regione Liguria</strong><br />(Regione Liguria - Responsabile della Protezione dei dati personali, Piazza De Ferrari 1 - 16121 Genova, email: <a href="mailto:rdp@regione.liguria.it">rdp@regione.liguria.it</a>; posta certificata <a href="mailto:protocollo@pec.regione.liguria.it">protocollo@pec.regione.liguria.it</a> ).</p>

            <h3>DIRITTO DI RECLAMO</h3>
            <p >Gli interessati che ritengono che il trattamento dei dati personali a loro riferiti effettuato attraverso questo sito avvenga in violazione di quanto previsto dal Regolamento hanno il diritto di proporre reclamo all'Autorità competente, che in Italia è rappresentata dall'Autorità Garante, come previsto dall'art. 77 del Regolamento stesso, o di adire le opportune sedi giudiziarie (art. 79 del Regolamento).</p>

            <h3>MODIFICHE ALLA PRESENTE INFORMATIVA</h3>
            <p >La presente informativa potrà subire delle variazioni. Si consiglia quindi di controllare regolarmente questa informativa e di riferirsi alla versione più aggiornata.</p>

            <h3>ULTIMO AGGIORNAMENTO</h3>
            MARZO 2019

            <br />
            <br />
          </div>
        </div>
      </Container>
    </main>
  )
}

export default SibaPrivacyPolicy;